import { render, staticRenderFns } from "./infoCard.vue?vue&type=template&id=5c3a2be1&scoped=true&"
import script from "./infoCard.vue?vue&type=script&lang=js&"
export * from "./infoCard.vue?vue&type=script&lang=js&"
import style0 from "./infoCard.vue?vue&type=style&index=0&id=5c3a2be1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a2be1",
  null
  
)

export default component.exports